import { Flex } from "@chakra-ui/react";
import { Release, ReleasePricingType } from "../../../types";
import { ReleasePriceLabel } from "../../cards/ReleasePriceLabel";
import { ReleaseActionsButtons } from "../../releases/components/ReleaseActionsButtons";
import { DiscountBanner } from "../../payments/components/DiscountBanner";
import { useUserData } from "../../../hooks/useUserData";
import { useReleasePricingInfo } from "../../../hooks/useReleasePricingInfo";
import { SaleBadge } from "../../cards/components/SaleBadge";
import {
  FunnelConfigTypes,
  FunnelContextArea,
  EventContextArea,
} from "../../funnel/types";

export interface ReleaseInfoActionsProps {
  release: Release;
  setFunnelConfig: (config: FunnelConfigTypes) => void;
  contextArea?: FunnelContextArea;
  eventContextArea?: EventContextArea;
}

export function ReleaseInfoActions({
  release,
  setFunnelConfig,
  contextArea,
  eventContextArea,
}: ReleaseInfoActionsProps) {
  const { userData } = useUserData();
  const userIsGold = userData?.gold ?? false;
  const releasePricingInfo = useReleasePricingInfo(release);

  const isALC =
    releasePricingInfo.type !== ReleasePricingType.Free &&
    releasePricingInfo.type !== ReleasePricingType.FreeWithGold;
  releasePricingInfo.type !== ReleasePricingType.Purchased;

  return (
    <Flex flexDirection="column" gap="12px">
      <SaleBadge release={release} showInCorner={false} />
      {isALC && <ReleasePriceLabel release={release} />}
      <DiscountBanner
        release={release}
        isGold={userIsGold}
        justifyContent="flex-start"
      />
      <ReleaseActionsButtons
        release={release}
        primaryButtonMaxWidth="250px"
        setFunnelConfig={setFunnelConfig}
        contextArea={contextArea}
        eventContextArea={eventContextArea}
      />
    </Flex>
  );
}
